import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import { useContainerStyles } from './styles';

const Container = ({ ...props }) => {
  const { children } = props;
  const classes = useContainerStyles();
  return (
    <Box className={classes.container} padding="21px" width="100%">
      {children}
    </Box>
  );
};

Container.propTypes = {
  children: PropTypes.node,
};

export default Container;
